import React from "react";
import youngMobileLogo from "../assets/images/young_mobile_sendQuestion.png";
import youngDesktopLogo from "../assets/images/young_desktop_sendQuestion.png";
import { useUser } from "../Hook/useUser";
import RatingModal from "./RatingModal";
import useMobile from "../Hook/UseMobile";

function SendQuestionContainer() {
	const { setModalQuestionIsOpen } = useUser();
	const isMobile = useMobile();

	const chooseLogo = () => {
		if (isMobile) {
			return youngMobileLogo;
		} else {
			return youngDesktopLogo;
		}
	};

	return (
		<div className="send-question">
            <RatingModal />
			<img className="send-question__img" src={chooseLogo()} alt="Tu n'as pas trouvé l'information que tu cherchais ?" />
			<button
				className="send-question-button"
				onClick={() =>
					setModalQuestionIsOpen({
						formModal: false,
						thanksModal: false,
						chatbotModal: true
					})
				}
			>
				Je pose ma question à Timi
			</button>
		</div>
	);
}

export default SendQuestionContainer;
